import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import logo from "../../asstes/images/logo.png";
import mobileLogo from "../../asstes/images/mobileLogo.png";
import mobileLogo2 from "../../asstes/images/Frame.png";
import ham from "../../asstes/images/hamberger.png";
import user from "../../asstes/images/user.png" 
import {MdOutlineClose} from "react-icons/md"
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../redux/store/auth/auth-slice';


const Navber = () => {


  const {userprofiledata} = useSelector((state)=>state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showNav,setShowNav] = useState(false)

  console.log(userprofiledata)

  const setProfileData = (data)=>{
    dispatch(authActions.adduserprofiledata(data))
    navigate("/profile")
    setShowNav(false)
  }

  const Logiut = ()=>{
    navigate("/")
    setShowNav(false)
  }


  return (
    <div className=' shadow-lg bg-white lg:h-[100px] h-[66px] fixed w-[100%] z-20 lg:hidden flex justify-between items-center'>
        <div className="container">
           <div className='flex items-center justify-between'>
               <div className='logo -mt-2'>
                  <Link className=" hidden lg:flex" to={"/"}><img src={logo}  alt=""/></Link>
                  <Link className=" lg:hidden" to={"/"}><img src={mobileLogo}  alt=""/></Link>
             </div>
              {/*   <ul className='lg:flex items-center gap-[70px] p-0 hidden'>
                  <li className='text-[20px] font-normal'>Cómo funciona</li>
                  <li className='text-[20px] font-normal'>Precios</li>
                  <li className='text-[20px] font-normal'>Dudas</li>
                  <li className='text-[20px] font-[700] text-[#4285F4]'>
                    <Link to={"/login"}>Regístrate | Inicia sesión</Link>
                  </li>
                </ul> */}
                

                {/* MObile Navber */}


                <div className='lg:hidden flex items-center gap-5'>
                    <img src={user} alt="" className='w-[20px]' />
                    <Link to={"/signup"}><button className=' bg-[#4285F4] py-2 px-4 text-white rounded-lg font-bold text-[16px]'>Regístrate</button></Link>
                    <button onClick={()=>setShowNav(true)}><img src={ham} alt="" className='w-[20px]' /></button>
                </div>

                <div className={`lg:hidden flex fixed top-0  w-[100%] h-screen opacity-100 duration-300 transition-all bg-[#4285F4] ${showNav ? "left-0" : "left-[-100%]"}`}>
                    <div className='px-[30px] w-full pt-[30px]'>
                        <div className='flex items-center justify-between w-full'>
                            <Link to={"/"}><img src={mobileLogo2} alt="" /></Link>
                            <button onClick={()=>setShowNav(false)} className='text-[30px] text-white'><MdOutlineClose/></button>
                        </div>
                        <div>
                        <div className='py-[80px]'>
                            <div className='flex flex-col gap-6 items-start text-[14px] text-white'>
                                <button onClick={()=>setProfileData("profile")} className={`${userprofiledata === "profile" ? "" : ""} ml-5 w-full text-left`}>Perfil</button>
                                <div className='w-full h-[2px] bg-white'></div>
                                <button onClick={()=>setProfileData("Información")} className={`${userprofiledata === "Información" ? "" : ""} ml-5 w-full text-left`}>Información General</button>
                                <div className='w-full h-[2px] bg-white'></div>
                                <button onClick={()=>setProfileData("Mi")} className={`${userprofiledata === "Mi" ? " " : ""} ml-5 w-full text-left`}>Mi Plan</button>
                                <div className='w-full h-[2px] bg-white'></div>
                                <button onClick={()=>setProfileData("Aviso")} className={`${userprofiledata === "Aviso" ? "" : ""} ml-5 w-full text-left`}>Aviso de Privacidad</button>
                                <div className='w-full h-[2px] bg-white'></div>
                                <button onClick={()=>Logiut()} className="ml-5 w-full text-left">Cerrar sesión</button>
                                <div className='w-full h-[2px] bg-white'></div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

          </div> 
        </div>
    </div>
  )
}

export default Navber